import { AscResponse, GetMyRankResponse } from '../../models';
import { httpService } from '../../utilities/axios.service';
import { RanksEndpoints } from './ranks.endpoints';

export async function getMyRankApi() {
  return httpService
    .get<AscResponse<GetMyRankResponse>>(RanksEndpoints.getMyRank)
    .then((res) => res?.data?.data);
}
